import React from 'react';
import PropTypes from 'prop-types';
import {Reset, Submit} from './Buttons';
import './style.scss';

/**
 * Footer:
 *  - The footer component for LableTestTube
 */
function Footer({children}) {
  const setClassName = (element) =>
    `${element.props.className} component_footer__button`;

  let content = null;

  if (Array.isArray(children)) {
    content = children.map((element, key) =>
      React.cloneElement(element, {
        ...element.props,
        key,
        className: setClassName(element),
      })
    );
  } else {
    content = React.cloneElement(children, {
      ...children.props,
      className: setClassName(children),
    });
  }

  return <div className='component_footer'>{content}</div>;
}

Footer.propTypes = {
  /**
   * list of button elements to be displayed on component.
   */
  children: PropTypes.element || PropTypes.array,
};

Footer.propTypes = {};

export {Footer, Submit, Reset};
